import { useMutation } from "react-query";
import templateFormHistoryService from "../../services/templateFormHistoryService";

const useAddTemplateFormHistoryAttachment = () => useMutation(templateFormHistoryService.addHistoricAttachment)

export default useAddTemplateFormHistoryAttachment;